module.exports = __webpack_public_path__ + "static/media/check-2.6e0ffba7.svg";